import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel safely
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Safely inject the FB pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '2828062277586055');
    window.fbq('track', 'PageView');
  }, []);
  return <SalesPage data-id="element-0" />;
}